export var AgeVerificationFlow;
(function (AgeVerificationFlow) {
    AgeVerificationFlow["GET_AGE_VERIFICATION_STATUS"] = "GetAgeVerificationStatus";
    AgeVerificationFlow["POST_AGE_VERIFICATION_INITIALIZE"] = "PostAgeVerificationInitialize";
    AgeVerificationFlow["POST_AGE_VERIFICATION_FINALIZE"] = "PostAgeVerificationFinalize";
    AgeVerificationFlow["GET_AGE_VERIFICATION_METHODS"] = "GetAgeVerificationMethods";
})(AgeVerificationFlow || (AgeVerificationFlow = {}));
